module.exports = __webpack_public_path__ + "static/vlad-0c4dae88aef51da8fbe9fa232cd4822c.jpg";